export default {
  paged: {
    select: 'id,status,type,number,start,end,reason,',
    searchSelect: ['reason', 'number'],
    expand: {
      sourceUser: { select: 'fullName' },
    },
  },
  item: {
    select:
      'id,status,type,number,start,end,reason,sourceUserId,delegatePendingTasks,keepSourceUserAsApproval,removeDelegatedTasksAtTheEnd',
    expand: {
      sourceUser: { select: 'id,fullName' },
    },
  },
  itemDetail: {
    select:
      'id,status,type,number,start,end,reason,created,updated,creator,modifier,sourceUserId,keepSourceUserAsApproval,removeDelegatedTasksAtTheEnd,delegatePendingTasks',
    expand: {
      sourceUser: { select: 'fullName' },
    },
  },
};
